import {Directive, TemplateRef} from '@angular/core';

@Directive({ selector: '[storeverDatatableActionsTemplate]' })
export class DataTableActionsTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
